const MotionGlobalConfig = {};

export { MotionGlobalConfig };
